import { Table } from '@tanstack/react-table';
import { type CleosTableFeaturesType } from '../tableFeatures';
import { SumRow } from './SumRow';
import styles from '../styles.module.scss';

interface TableFooterProps<TData extends object> {
  table: Table<CleosTableFeaturesType, TData>;
  sumable?: boolean;
  expandable?: boolean;
}

export const TableFooter = <TData extends object>({ table, sumable, expandable }: TableFooterProps<TData>) => {
  if (!sumable) return null;
  return (
    <tfoot className={styles.footer}>
      <SumRow table={table} expandable={expandable} />
    </tfoot>
  );
};
